import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';

const serviceItems = [
    {
        id: 1,
        title: "Automate dispatch to match jobs with right tech",
        description: "Streamline communication, onboarding, and lifecycle management across vendor networks with connected, transparent digital workflows.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Boost field tech performance with AI-guided insights",
        description: "Automate requisition approvals, contract analysis, and order execution to cut cycle times and eliminate manual bottlenecks.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Eliminate silos with connected, automated field workflows",
        description: "Track enterprise expenditure, monitor third-party compliance, and benchmark supplier metrics through live, data-driven dashboards.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];


const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "We assess your current environment, identify automation opportunities, and design a phased plan aligned with your business goals.[cite: 23]",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We configure and integrate ServiceNow modules tailored to your needs ITSM, ITOM, HRSD, CSM, CRM, and more ensuring seamless platform adoption.[cite: 23]",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "We build intelligent, data-driven workflows and AI models that streamline operations across sales, service, IT, and security.[cite: 23]",
        products: []
    }
];

const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers drive digital innovation across production, maintenance, and supply chain operations through intelligent automation and AI-powered insights.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Our innovation frameworks enable financial institutions to modernize operations, enhance customer experiences, and maintain compliance in highly regulated environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Retail organizations leverage our AI-driven innovation capabilities to improve customer engagement, optimize operations, and deliver seamless omnichannel experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help telecom providers innovate across customer service, network operations, and field service through intelligent workflows and scalable digital platforms.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "110+ Certifications",
        desc: "110+ Automation Engine and ServiceNow certifications across our team."
    },
    {
        id: 2,
        title: "AI-First Approach",
        desc: "AI-first approach to accelerate risk insights and response."
    },
    {
        id: 3,
        title: "Performance Optimization",
        desc: "Optimize Automation Engine performance, efficiency, and reduce manual effort."
    },
    {
        id: 4,
        title: "Custom Integrations",
        desc: "Customize Automation Engine workflows, features, and system integrations."
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What are the features of ServiceNow workflow automation?",
        answer: "ServiceNow workflow automation features include Flow Designer for low-code process modeling, Process Automation Designer for cross-enterprise orchestration, Integration Hub spokes, RPA Hub for unattended/attended bots, and Document Intelligence for automated data extraction."
    },
    {
        id: 2,
        question: "How to create a business case for automation?",
        answer: "To build a strong business case, identify manual bottlenecks, quantify time and labor savings, project error reduction rates, evaluate SLA improvements, and compare implementation costs against long-term operational ROI."
    },
    {
        id: 3,
        question: "What are the benefits of ServiceNow automation?",
        answer: "Key benefits include accelerated cycle times, lower operational costs, improved process compliance, standardized service delivery, reduced human error, and enhanced experiences for both employees and customers."
    },
    {
        id: 4,
        question: "What are some examples of ServiceNow automation?",
        answer: "Common examples include automated employee onboarding/offboarding, IT incident auto-routing and remediation, purchase requisition approval pipelines, automated password resets, and invoice extraction."
    },
    {
        id: 5,
        question: "What skills are needed for ServiceNow automation?",
        answer: "Teams benefit from skills in ServiceNow Flow Designer, JavaScript/GlideScript for advanced actions, REST/SOAP API integrations, RPA bot development, and a strong understanding of core business workflow logic."
    },
    {
        id: 6,
        question: "How can ServiceNow automation be implemented?",
        answer: "Implementation follows a phased approach: assessing existing processes, prioritizing high-impact use cases, configuring workflows using Flow Designer and Integration Hub, testing in sub-production environments, and rolling out with change management."
    },
    {
        id: 7,
        question: "What is the role of AI and ML in ServiceNow automation?",
        answer: "AI and Machine Learning power capabilities like Predictive Intelligence for auto-categorization and routing, Virtual Agents for conversational self-service, and Generative AI (Now Assist) for summarization and contextual code/workflow generation."
    },
    {
        id: 8,
        question: "What are ServiceNow Automation Discovery?",
        answer: "Automation Discovery analyzes historical business and ITSM/CSM interaction data using machine learning to identify high-volume, repetitive opportunities best suited for Virtual Agent and automated workflow deflection."
    }
];

const expectItems = [
    "Workflow Automation",
    "AI Automation",
    "IT Operations Automation",
    "Business Process Automation (BPA)",
    "Service Desk Automation",
    "Test Automation",
    "Security Automation",
    "IT Infrastructure Automation"
];

function Automation() {
    return (
        <div>
            <WhoHero
                title="Simplify, Accelerate, and Transform with ServiceNow Automation"
                text="Achieve enterprise-wide business transformation with ServiceNow & Aelum"
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Supercharge enterprises with AI-Driven Innovation" description="Innovation today goes beyond experimenting with new technologies. Organizations need to turn ideas into solutions that improve operations, create better experiences, and drive measurable results. Many enterprises explore AI, automation, and digital tools but struggle to scale them across the business. Mobikode helps organizations move from experimentation to execution. By combining AI capabilities, intelligent automation, and digital engineering, we help enterprises build scalable solutions that improve efficiency, enable faster decisions, and support long-term growth." /> */}
            <ServiceX360ViewSection title="Redefining Enterprise Efficiency with ServiceNow Automation Solutions" description="Intelligent automation, what was once seen as an ‘add-on’, is now an absolute necessity. It enables faster decisions, eliminates manual tasks, and ensures consistent, high-quality service across every department. Aelum helps you utilize the full potential of ServiceNow Automation solutions to streamline workflows, unify systems, and build smarter processes. From IT to customer service, we design intelligent automation solutions that adapt to your business and scale with your growth so your people can focus on what truly matters: innovation, speed, and customer satisfaction." serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow Automation Services" description="Optimize field operations, boost service efficiency, and elevate customer satisfaction with ServiceNow FSM" />
            <WhatToExpectSection title="What to expect from ServiceNow Automation" description="ServiceNow Automation Engine brings together sourcing, procurement, and finance into a unified experience:" expectItems={expectItems} />
            {/* <IndustriesServiceExperienceSection title="Accelerating Innovation Across Industries" industryTabs={industryTabs} /> */}
            <WeCanAlsoHelpWithSection />
            <WhatSetsApartSection title="Why Mobikode for ServiceNow Automation Engine? " description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default Automation
